/**
 * Single cap for event cover + album image uploads (one file).
 * Server: `uploadImage` / `assertImageUploadValidated` in `server/services/media.service.ts`.
 */
export const MAX_IMAGE_UPLOAD_BYTES = 20 * 1024 * 1024
